module.exports = __webpack_public_path__ + "b6875ac1cd2a70fe1916cade9f770b23.svg";